import React from 'react'
import PlanEntryListRow from './PlanEntryListRow'
import PropTypes from 'prop-types'
import ReactSortable from 'react-sortablejs'
import './PlanEntriesListRows.scss'

const PlanEntriesListRows = ({
  entries,
  favoritable,
  featurable,
  sortable,
  onDeleted,
  removable,
  locked,
  includeDates,
  onSortEnd,
  entryLinkSuffix
}) => {
  const planEntryItems = entries.map(entry => (
    <PlanEntryListRow
      key={entry.id}
      entryId={entry.obj.id}
      dataId={entry.obj.id}
      planEntry={entry.obj}
      dateAdded={entry.createdAt}
      removable={removable}
      favoritable={favoritable}
      featurable={featurable}
      sortable={sortable}
      locked={locked}
      onDeleted={() => {
        onDeleted(entry.id)
      }}
      includeDates={includeDates}
      entryLinkSuffix={entryLinkSuffix}
    />
  ))

  const planEntryRows = (
    <ReactSortable
      onChange={(items, __, evt) => {
        onSortEnd(items, evt)
      }}
      options={{
        animation: 150,
        disabled: !sortable
      }}
    >
      {planEntryItems}
    </ReactSortable>
  )

  return <div className='PlanEntriesListRows'>{planEntryRows}</div>
}

PlanEntriesListRows.propTypes = {
  entries: PropTypes.array,
  favoritable: PropTypes.bool,
  featurable: PropTypes.bool,
  sortable: PropTypes.bool,
  onDeleted: PropTypes.func,
  removable: PropTypes.bool,
  locked: PropTypes.bool,
  includeDates: PropTypes.bool,
  onSortEnd: PropTypes.func,
  entryLinkSuffix: PropTypes.string
}

export default PlanEntriesListRows
